(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-reassurance"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-mtg-cookie-preferences]');
    if (!trigger) return;

    var preferenceButton = document.querySelector(
      '#shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs, [data-privacy-preferences-button]'
    );
    if (preferenceButton) preferenceButton.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marques-jardin"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-carousel')) {
    customElements.define('brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-brand-viewport]');
        this.previousButton = this.querySelector('[data-brand-previous]');
        this.nextButton = this.querySelector('[data-brand-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.viewport) return;
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.viewport.addEventListener('pointerdown', () => this.stop());
        this.viewport.addEventListener('pointerup', () => this.start());
        this.start();
      }
      cardWidth() { const card = this.querySelector('.mtg-brand-carousel__card'); const track = this.querySelector('.mtg-brand-carousel__track'); if (!card || !track) return 0; return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0); }
      move(direction) { const distance = this.cardWidth(); if (!distance) return; const end = this.viewport.scrollWidth - this.viewport.clientWidth; let target = this.viewport.scrollLeft + direction * distance; if (target > end - 4) target = 0; if (target < 0) target = end; this.viewport.scrollTo({ left: target, behavior: this.reduceMotion ? 'auto' : 'smooth' }); }
      start() { if (this.reduceMotion || this.querySelectorAll('.mtg-brand-carousel__card').length < 2) return; this.stop(); this.timer = window.setInterval(() => this.move(1), 3800); }
      stop() { window.clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mnav-open-drawer]');
    if (!trigger) return;

    var headerDrawerToggle = document.querySelector('header-drawer summary.header__icon--menu, header-drawer .header__icon--menu, header-drawer summary');
    if (headerDrawerToggle) {
      headerDrawerToggle.click();
      return;
    }

    window.location.href = '/collections/all';
  });

  } catch(e) { console.error(e); }
})();
})();
